import { createStore, createHook } from '@atlassian/react-sweet-state';
import type { MoreMenuOpenTrigger, MoreMenuSharedActions, MoreMenuSharedState } from './types.tsx';

export const initialState: MoreMenuSharedState = {
	isOpen: false,
	openTrigger: null,
};
export const actions: MoreMenuSharedActions = {
	open:
		(trigger: MoreMenuOpenTrigger) =>
		({ setState }) => {
			setState({ isOpen: true, openTrigger: trigger });
		},
	close:
		() =>
		({ setState }) => {
			setState({ isOpen: false, openTrigger: null });
		},
};

export const CalendarMoreMenuStore = createStore({
	initialState,
	actions,
	name: 'calendar-more-menu-store',
});

export const useCalendarMoreMenuStore = createHook(CalendarMoreMenuStore);
